import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "position-relative" }
const _hoisted_2 = { class: "custom-select js-custom-select" }
const _hoisted_3 = ["name", "id", "value", "required"]
const _hoisted_4 = ["data-bs-display"]
const _hoisted_5 = { class: "custom-select__btn-text js-custom-select__value-label" }
const _hoisted_6 = { class: "custom-select__dropdown dropdown-menu" }
const _hoisted_7 = ["data-value", "selected"]

import { onMounted, nextTick, ref } from "vue";
import FormLabel from "../form-elements/includes/FormLabel.vue";
import FormErrors from "../form-elements/includes/FormErrors.vue";
// @ts-ignore
import * as customSelect from "../../../../scripts/custom-select";
import Select from "./Select.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomSelect',
  props: {
  id: {
    default: null,
    required: true,
    type: String
  },
  required: {
    type: Boolean,
    default: false
  },
  label: {
    type: String,
    required: true,
  },
  labelClassName: {
    type: String,
    required: false,
    default: null
  },
  selectClassName: {
    type: String,
    required: false,
    default: null
  },
  name: {
    type: String,
    required: true,
  },
  description: {
    type: String,
    required: false
  },
  options: {
    default: [],
    type: Array,
    required: false
  },
  selectedOption: {
    type: String,
    required: false,
    default: null
  },
  placeholder: {
    type: String,
    required: false,
    default: ""
  },
  changeValue: {
    type: Function,
    required: false,
    default: null
  },
  className: {
    type: String,
    required: false,
    default: null
  },
  wrapperClassName: {
    type: String,
    required: false,
    default: null
  },
  staticBottom: {
    type: Boolean,
    required: false,
    default: false
  }
},
  emits: ['changeValue', 'update:modelValue'],
  setup(__props, { emit }) {

const props = __props;

// @ts-ignore



const errors = [];

const selected = ref(props.selectedOption || null);
const selectedLabel = ref('');

const onChangeValue = (e: string, isFirstUpdate: boolean) => {
  selected.value = e;
  emit('changeValue', e, isFirstUpdate);
};

onMounted(() => {
  nextTick(customSelect.init());
  //set selectedOption to first option if no option is selected
  if(!props.selectedOption && props.options.length !== 0){
    //if one of the options is selected, set selected to this option
    if(props.options.some((option) => option.selected)){
      const option = props.options.find((option) => option.selected);
      emit('update:modelValue', option.value);
      onChangeValue(option.value, true);
      selected.value = option.value;
      selectedLabel.value = option.label;

    }else{
      if(props.placeholder){
        selectedLabel.value = props.placeholder;
      }else{
        emit('update:modelValue', props.options[0].value);
        onChangeValue(props.options[0].value, true);
        selected.value = props.options[0].value;
        selectedLabel.value = props.options[0].label;
      }
    }
  }
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass('form-group js-form-validation__group ' + __props.className)
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(FormLabel, {
        label: __props.label,
        id: __props.id,
        required: __props.required,
        class: _normalizeClass(__props.labelClassName)
      }, null, 8, ["label", "id", "required", "class"]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("input", {
          class: "js-custom-select__input form-control visually-hidden",
          name: __props.name,
          id: __props.id,
          value: selected.value,
          required: __props.required,
          onChange: _cache[0] || (_cache[0] = ($event: any) => (onChangeValue($event.target.value, false))),
          onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:modelValue', $event.target.value))),
          tabindex: "-1"
        }, null, 40, _hoisted_3),
        _createElementVNode("button", {
          type: "button",
          class: "custom-select__btn js-custom-select__button dropdown-toggle form-control",
          "data-bs-display": __props.staticBottom ? 'static' : null ,
          "data-bs-toggle": "dropdown",
          "aria-expanded": "false"
        }, [
          _createElementVNode("span", _hoisted_5, _toDisplayString(selectedLabel.value || __props.placeholder), 1)
        ], 8, _hoisted_4),
        _createElementVNode("ul", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (option) => {
            return (_openBlock(), _createElementBlock("li", null, [
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass(["dropdown-item js-custom-select__item", option.disabled ? 'disabled' : '']),
                "data-value": option.value,
                selected: option.selected
              }, _toDisplayString(option.label), 11, _hoisted_7)
            ]))
          }), 256))
        ])
      ])
    ]),
    _createVNode(FormErrors, { errors: errors })
  ], 2))
}
}

})